export const columns =[
  {
    title: '文件类型',
    dataIndex: 'type',
    key: 'type',
    ellipsis:true,
    width:'150'
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreated',
    ellipsis:true,
    key: 'gmtCreated',
  },
  {
    title: '任务类型',
    dataIndex: 'taskType',
    ellipsis:true,
    key: 'taskType',
  },
  {
    title: '状态',
    dataIndex: 'status',
    ellipsis:true,
    key: 'status',
  },
  {
    title: '说明',
    dataIndex: 'errorMsg',
    ellipsis:true,
    key: 'errorMsg',
  },
  {
    title: '操作',
    key: 'operation',
    width:'50'
  },
]